export type CalculatorInputs = {
  monthlyCalls: number;
  missedPercentage: number;
  opportunityPercentage: number;
  averageJobValue: number;
};

export type CalculatorResult = {
  missedCalls: number;
  potentialOpportunities: number;
  potentialRevenueAtRisk: number;
  jobsToCoverMonthlyFee: number;
};

const nonNegative = (value: number) => Number.isFinite(value) ? Math.max(0, value) : 0;

export function calculateRevenueRisk(inputs: CalculatorInputs, recurringPrice = 399): CalculatorResult {
  const monthlyCalls = nonNegative(inputs.monthlyCalls);
  const missedRate = Math.min(100, nonNegative(inputs.missedPercentage)) / 100;
  const opportunityRate = Math.min(100, nonNegative(inputs.opportunityPercentage)) / 100;
  const averageJobValue = nonNegative(inputs.averageJobValue);
  const missedCalls = monthlyCalls * missedRate;
  const potentialOpportunities = missedCalls * opportunityRate;
  return {
    missedCalls,
    potentialOpportunities,
    potentialRevenueAtRisk: potentialOpportunities * averageJobValue,
    jobsToCoverMonthlyFee: averageJobValue > 0 ? recurringPrice / averageJobValue : 0,
  };
}
